import { render, staticRenderFns } from "./comTerm12.vue?vue&type=template&id=5816dd9e&scoped=true&"
import script from "./comTerm12.vue?vue&type=script&lang=js&"
export * from "./comTerm12.vue?vue&type=script&lang=js&"
import style0 from "./comTerm12.vue?vue&type=style&index=0&id=5816dd9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816dd9e",
  null
  
)

export default component.exports